// extracted by mini-css-extract-plugin
export var avatarContainer = "_47-1";
export var largeAvatarContainer = "_47-2";
export var smallAvatarContainer = "_47-0";